import { IUser } from '../../modules/Auth/models/user.model';

declare global {
  interface Window {
    wootric: any;
    wootricSettings: any;
    wootric_survey_immediately: boolean;
  }
}

export const loadWootric = (user: IUser | null) => {

  if (!user ||
    !user.email ||
    !user.createdAt ||
    (user.role || []).includes('admin')) {
    return;
  }

  try {
    //window.wootric_survey_immediately = true; // Shows survey immediately for testing purposes. Comment out for production.
    window.wootricSettings = {
      email: user.email,
      external_id: user.id,
      created_at: Math.floor(new Date(user.createdAt).getTime() / 1000),
      account_token: 'NPS-ba40f21b',
      properties: {
        isB2B: user.isB2B,
        B2BCompany: user.isB2B ? user.B2BCompany : "Aprova Total",
      }
    };

    const wootricScript = document.createElement('script');
    wootricScript.type = 'text/javascript';
    wootricScript.src = 'https://cdn.wootric.com/wootric-sdk.js';
    wootricScript.async = true;
    wootricScript.onload = () => {
      if (window.wootric) {
        window.wootric('run');
      }
    };

    document.body.appendChild(wootricScript);
  } catch (e) {
    console.error('Failed to load Wootric:');
  }
};
